import { useEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import {
	selectPersonsError,
	selectPersonListLoader,
	selectPersonsMap,
	selectPersonBookList,
} from '../../model/selector';
import { BasicCard } from 'shared/ui/cards/basicCard';
import { GridTable } from 'shared/ui/gridTable';
import { usePerson } from '../../lib/hooks/usePerson';
import { Content, PersonName } from './styles';
import { PersonBookHeader } from './personBookHeader';
import { GridRows } from 'shared/ui/gridTable/types';
import { Truncate } from 'shared/ui/truncate';
import { Typography } from 'shared/ui/typography';
import { usePaginationFilterPersons } from 'shared/lib/pagination';
import { PaginationHook } from 'shared/lib/pagination';
import { useModal } from 'shared/lib/modal';
import { setSelectedPerson } from 'entities/person/model/personSlice';
import { selectBookingApplicationMod } from 'entities/orders';
import { formatPhoneNumber } from 'shared/lib/string';
import { selectSettingDefaultPerson } from 'entities/settings';

export const PersonBook = () => {
	const persons = useAppSelector(selectPersonBookList);
	const personsMap = useAppSelector(selectPersonsMap);
	const isLoadingGeneral = useAppSelector(selectPersonListLoader);
	const error = useAppSelector(selectPersonsError);
	const { isOpenPersonBook, setOpenPersonBook, setPerson } = usePerson();
	const bookingApplicationMod = useAppSelector(selectBookingApplicationMod);
	const defaultPerson = useAppSelector(selectSettingDefaultPerson);

	const { loadMore, isLoading, fetchDataWithDispatch } =
		usePaginationFilterPersons() as PaginationHook;
	const personBookingOpened = useRef(false);

	const [rows, setRows] = useState<GridRows[]>([]);
	const [headers] = useState([
		'Имя и фамилия',
		'Номер телефона',
		'Комментарий',
	]);

	useEffect(() => {
		if (bookingApplicationMod && !personBookingOpened.current) {
			fetchDataWithDispatch({ search: '', page: 1 });
			personBookingOpened.current = true;
		}
	}, [bookingApplicationMod, fetchDataWithDispatch]);

	useEffect(() => {
		if (bookingApplicationMod) {
			setOpenPersonBook(true);
		} else {
			setOpenPersonBook(false);
		}
	}, [setOpenPersonBook, bookingApplicationMod]);

	useEffect(() => {
		if (persons.length) {
			const personMap = persons.map(person => {
				return {
					id: person.id,
					fields: [
						<Truncate>
							<PersonName>
								<Typography truncate={true} pointer>
									{person.name}
								</Typography>
							</PersonName>
						</Truncate>,
						formatPhoneNumber(person.phone),
						person.notes,
					],
				};
			});

			setRows([{ rows: [{ cells: personMap }] }]);
		} else {
			setRows([]);
		}
	}, [persons]);

	const dispatch = useAppDispatch();
	const { openModal } = useModal();

	const selectPerson = (personId: number) => {
		const person = personsMap.get(String(personId));

		if (personId === defaultPerson && person) {
			setPerson(person);
			setOpenPersonBook(false);

			return;
		}

		if (person) {
			openModal();
			dispatch(setSelectedPerson(person));
		}
	};

	return (
		<BasicCard show={isOpenPersonBook} variant={'secondary'}>
			<Content>
				<PersonBookHeader />
				<GridTable
					headers={headers}
					isFixedHeader
					tableRows={rows}
					columnCount={2}
					onClickOnCard={selectPerson}
					onScrollEnd={loadMore}
					isLoading={isLoadingGeneral}
					isLoadingBottom={isLoading}
					error={error}
					gridSettings={{
						columnSize: 3,
						trackSize: 3,
					}}
					specificColumnSizes={[
						{ index: 1, size: 3 },
						{ index: 2, size: 2 },
						{ index: 3, size: 3 },
					]}
				/>
			</Content>
		</BasicCard>
	);
};
